export default __webpack_public_path__ + "static/media/1_0110.6483d359.webp";